export enum GridRemove {
    None = 1,
    All = 2,
    First = 3,
    Last = 4
}